var _rect, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltAssembly(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 400,
    viewBox: "0 0 200 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 20,
    height: 40,
    fill: "#7f8c8d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 30,
    width: 60,
    height: 40,
    fill: "#bdc3c7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 30,
    width: 20,
    height: 40,
    fill: "#95a5a6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 70,
    width: 110,
    height: 8,
    fill: "#ecf0f1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 78,
    width: 50,
    height: 242,
    fill: "#7f8c8d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#95a5a6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 100,
    x2: 125,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 115,
    x2: 125,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 130,
    x2: 125,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 145,
    x2: 125,
    y2: 145
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 160,
    x2: 125,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 175,
    x2: 125,
    y2: 175
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 190,
    x2: 125,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 205,
    x2: 125,
    y2: 205
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 220,
    x2: 125,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 235,
    x2: 125,
    y2: 235
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 250,
    x2: 125,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 265,
    x2: 125,
    y2: 265
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 280,
    x2: 125,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 295,
    x2: 125,
    y2: 295
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 310,
    x2: 125,
    y2: 310
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 200,
    width: 18,
    height: 45,
    fill: "#7f8c8d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 200,
    width: 54,
    height: 45,
    fill: "#bdc3c7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 200,
    width: 18,
    height: 45,
    fill: "#95a5a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltAssembly);
export default __webpack_public_path__ + "static/media/bolt-assembly.e93411e60fcebd39d2a762201c385a20.svg";
export { ForwardRef as ReactComponent };